import { useEffect } from "react";
import { useState } from "react";
import "./App.css";
import HeroPage from "./components/HeroPage";
import Main from "./components/Main";
import Navbar from "./components/Navbar";
import Service from "./components/Service";
import HashLoader from "react-spinners/HashLoader";
import AboutMe from "./components/AboutMe";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import Contact from "./components/Contact";
import Footer from "./components/Footer";
AOS.init();

function App() {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <div className="container">
      {isLoading ? (
        <div className="flex items-center justify-center h-screen">
          <HashLoader size={100} loading={isLoading} color={"white"} />
        </div>
      ) : (
        <>
          <div className="flex items-center justify-center ">
            <HeroPage />
          </div>
          <div className="App">
              <Navbar />
              <section id="about">
              <Main />

              </section>
              <AboutMe/>
              <section id="service">
              <Service  />
              </section>
              <section id="contact">
              <Contact/>

              </section>
              <Footer/>
          </div>
        </>
      )}
    </div>
  );
}

export default App;
